import React from 'react';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GetEstimateForm from '../EstimateForm';

const SectionGetQuoteFormCalculator = () => {

  return (
    <div className='estimate-calculator-form'>
      <GetEstimateForm layout='form'></GetEstimateForm>
      <ToastContainer position="bottom-center" autoClose={8000} />

    </div>
  );

}
export default SectionGetQuoteFormCalculator